import { UserRole } from "../../types";
import ApiModule from "../base";

export default class RegistrationsModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "auth/sessions");
  }

  async create(
    email: string,
    password: string,
  ): Promise<{ jwtToken: string; role: UserRole }> {
    const request = new Request(this.url, {
      method: "POST",
      headers: this._defaultHeaders(),
      body: JSON.stringify({ email, password }),
    });
    return await this._resolve(request);
  }
}
